import React from 'react';

const TextQuestionBlock = ({ question, register, errors }) => {
    // Build validation rules dynamically
    const validationRules = {
        required: question.required ? `${question.title} is required` : false,
        maxLength: question.maxLength || undefined,
        min: question.minValue || undefined,
        max: question.maxValue || undefined,
    };

    // Extra pattern/validation per type
    switch (question.inputType) {
        case "email":
            validationRules.pattern = {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Please enter a valid email address",
            };
            break;
        case "url":
            validationRules.pattern = {
                value: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/,
                message: "Please enter a valid URL",
            };
            break;
        case "tel":
            validationRules.pattern = {
                value: /^[+]?[0-9\s-]{7,15}$/,
                message: "Please enter a valid phone number(+1 555-123-4567,5551234567)",
            };
            break;
        case "number":
        case "range":
            validationRules.valueAsNumber = true;
            break;
        case "date":
        case "time":
        case "datetime-local":
        case "month":
        case "week":
            validationRules.valueAsDate = true;
            break;
        default:
            break;
    }

    return (
        <div className="mb-4">
            <label className="form-label mb-0">
                {question.title} {question.required && "*"}
            </label>
            {question.description && (
                <p className="text-muted">
                    <small>{question.description}</small>
                </p>
            )}
            <input
                type={question.inputType || "text"}
                className="form-control"
                placeholder={question.placeholder}
                {...register(question.internalId, validationRules)}
            />
            {errors[question.internalId] && (
                <div className="text-danger small">{errors[question.internalId].message}</div>
            )}
        </div>
    );
};

export default TextQuestionBlock;
